import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isCoffeeFundraisingAllowed } from '../services/coffee/is-coffee-fundraising-allowed';
import { TripService } from '../services/trip.service';

export const coffeeFundraisingGuard: CanActivateFn = () => {
  const tripService = inject(TripService);
  const router = inject(Router);

  if (!tripService.currentTripLoaded()) {
    return true;
  }

  const trip = tripService.currentTrip.value();
  return isCoffeeFundraisingAllowed(trip)
    ? true
    : router.createUrlTree(['/dashboard']);
};
